import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import type { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import { filter, first, map } from 'rxjs/operators';
import { AuthSessionStore } from '../+state';
import { navigateOrReport } from '../util/navigate-or-report.util';

/**
 * Route guard restricting activation to `buyer` users (or `admin`, who
 * may act on a buyer's behalf for support work).
 *
 * Used for buyer-only surfaces such as the Project workspace per
 * `docs/product/05-roles-and-permissions.md` Projects table.
 */
export const buyerGuard: CanActivateFn = () => {
  const authStore = inject(AuthSessionStore);
  const router = inject(Router);

  return toObservable(authStore.authenticationInitialized).pipe(
    filter((initialized): boolean => initialized),
    first(),
    map(() => {
      if (authStore.isBuyer() || authStore.isAdmin()) {
        return true;
      }
      navigateOrReport(router, ['/'], 'Navigation to home failed');
      return false;
    })
  );
};
